import { useLang } from "@/lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-neutral-200 py-6 overflow-hidden bg-white"
    >
      <div className="marquee whitespace-nowrap">
        {items.map((m, i) => (
          <span
            key={i}
            className="font-serif italic text-2xl md:text-3xl text-neutral-700 mx-8 flex items-center gap-8"
          >
            {m}
            <span className="text-neutral-300 not-italic font-sans">—</span>
          </span>
        ))}
      </div>
    </section>
  );
};
